document.addEventListener('DOMContentLoaded', () => {
  const notifySelectors = {
    drawer: '#notify-drawer',
    email: '.notify__email',
    errorDrawer: '#notify-drawer-error',
    notifyLink: '.notify-me',
    terms: '.notify__terms',
    subscribe: '.notify__subscribe',
    successDrawer: '#notify-drawer-success',
    variant: '.notify__variant',
  };

  function getKlaviyoPublicApiKey() {
    const notifyDrawer = document.querySelector(notifySelectors.drawer);
    return notifyDrawer?.dataset.klaviyoKey;
  }

  function addBackInStockSubscription(event) {
    const notifyDrawer = document.querySelector(notifySelectors.drawer);
    const email = notifyDrawer?.querySelector(notifySelectors.email)?.value;
    const variantId = notifyDrawer?.querySelector(notifySelectors.variant)?.value;
    const termsCheckboxChecked = notifyDrawer?.querySelector(notifySelectors.terms)?.checked;
    if (email && variantId && termsCheckboxChecked) {
      event.preventDefault();
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2025-01-15',
        },
        body: JSON.stringify(payload),
      };

      fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${getKlaviyoPublicApiKey()}`,
        requestOptions,
      )
        .then((result) => {
          closeAllDrawers();
          if (result.status === 200 || result.status === 202) {
            document.querySelector(notifySelectors.successDrawer)?.open();
          } else {
            document.querySelector(notifySelectors.errorDrawer)?.open();
          }
        })
        .catch(() => {
          closeAllDrawers();
          document.querySelector(notifySelectors.errorDrawer)?.open();
        });
    }
  }

  function addNotifyEvents() {
    const notifyLinks = document.querySelectorAll(notifySelectors.notifyLink);
    notifyLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        selectedVariantId = link.dataset.variantId;
        closeAllDrawers();
        document.querySelector(notifySelectors.drawer)?.open(() => {
          const sizeSelect = document.querySelector(notifySelectors.variant);
          if (sizeSelect) {
            sizeSelect.value = selectedVariantId;
          }
        });
      });
    });

    const subscriptionButton = document.querySelector(notifySelectors.subscribe);
    if (subscriptionButton) {
      subscriptionButton.addEventListener('click', addBackInStockSubscription);
    }
  }

  addNotifyEvents();
});
